var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-form-checkbox',{attrs:{"checked":_vm.checked},on:{"input":_vm.handleChange}},[_c('gl-sprintf',{attrs:{"message":_vm.i18n.checkboxMessage},scopedSlots:_vm._u([{key:"link",fn:function({ content }){return [_c('gl-link',{attrs:{"href":_vm.i18n.exportHelpPath,"target":"_blank"}},[_vm._v("\n        "+_vm._s(content)+"\n      ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }